export const styles = {
  ellipsis: (animationDelay: string) => ({
    opacity: 0,
    animation: 'opacity-loop 1.3s infinite',
    padding: '0 0.1rem',
    animationDelay,
  }),
};
